<fz-filter-panel
  [facet]="data.facet"
  [filters]="filters()"
  (filterChange)="selectionChange($event)"
  (clear)="clear()"
></fz-filter-panel>

<div class="fz-mobile-filters__actions">
  <button
    mat-raised-button
    color="primary"
    class="full-width"
    data-ga-value="user-show-results"
    data-testid="btn-show-results"
    (click)="showResults()"
  >
    Show results
  </button>
</div>
